
<template>
  <div class="mypost">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    :immediate-check="false"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="list-box" v-for="(item,index) in list" :key="'list_' + item.id">
     <router-link :to="{name: 'LexusBbsShow', params: {id: item.id}}">
      <div class="listitle ellipsis-2">{{item.title}}</div>
      <div class="f-15 ellipsis-4">{{item.content}}</div>
    </router-link>
    <router-link :to="{name: 'LexusBbsShow', params: {id: item.id}}">
      <div class="pic-box" v-if="item.image.length>0">
        <img class="pic_thumb" v-lazy="item.image[0]">
      </div>
      <div v-if="item.video">
        <iframe
        style="z-index:1;"
        :src="item.video"
        allowfullscreen=""
        frameborder="0"
        height="100%"
        width="100%"
        >
      </iframe>
    </div>
  </router-link>
  <van-row type="flex" justify="space-between">
    <van-col span="18">
      <span class="binbox">
        <img @click="setPraise(index)" class="binpic" :src="item.is_praise==1? img.collect_have: img.collect">
        <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
      </span>
      <span class="binbox">
        <img class="binpic" :src="img.comment">
        <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
      </span>
      <span class="binbox" hidden="true">
        <img class="binpic" :src="img.inrelay">
        <span class="statenum"></span>
      </span>
    </van-col>
    <van-col class="bintright" span="6" @click="outrelay(item.title,item.content,'/lexus/bbs/'+item.id,item.image[0])">
      <img class="binpic" :src="img.outrelay">
    </van-col>
  </van-row>
  <van-tag v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4">#{{tag.name}}#</van-tag>
  <div class="tag">
    <span class="f-r c-gray f-12" @click="delBbs(item.id)">删除</span>
  </div>
</div>
</van-list>
<div v-if="list.length==0" class="nodata">暂无数据</div>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="5">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/mybbs';
  import bbs from '../../../api/bbs';
  import { mapState } from 'vuex';
  import {  List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,ActionSheet,Divider} from 'vant';
  
  export default {
    data(){
      return{
        list: [],
        page:1,
        cid:4,
        user_id:'',
        loading: false,
        finished: false,
        num:10,
        shareshow:false,
        img: {
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          location: require('../../../assets/img/lexus/location.png'),
          avatar: require('../../../assets/img/lexus/default.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      let params={
        cid:4,
        page:this.page,
      }
      this.getMypost(params)
      var paramsd={
        event_code: '我的发布',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyBbs.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(paramsd).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getMypost(params){
        list.getMypost(params).then(res => {
          if(res.data.state == 1) {
            let list=this.list
            let newlist=res.data.data.data
            if(list.length==0){
              this.list = res.data.data.data
            }else{
              this.num=newlist.length
              this.list = this.list.concat(newlist)
            }
          }
        })
      },
      setPraise (index) {
        let type = this.list[index].is_praise ? 2 : 1;
        bbs.setPraise({id: this.list[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.list[index].is_praise = 1
              this.list[index].praise_num += 1
            } else {
              this.list[index].is_praise = 0
              this.list[index].praise_num -= 1
            }
          }
        })
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        this.shareshow=true
        this.sharetitle=title
        this.sharecontent=content
        this.shareurl=this.weburl+url
        if(imageUrl){
          this.shareimageUrl=imageUrl
        }else{
          this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
        }
        
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      toTip() {
        this.$toast.success('举报成功')
      },
      delBbs(id){
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
          bbs.delBbs(id).then(res => {
            if(res.data.state == 1) {
              let list=this.list
              for (var i=0;i<list.length;i++) {
                if(list[i].id==id){
                 list.splice(i, 1)
               }
             }
             this.list=list
             this.$toast.success('删除成功');
           }
         })
        }).catch(() => {
        });
      },
      onLoad() {
      // 异步更新数据
      setTimeout(() => {
        let num=this.num
        if (num <10) {
          this.finished = true
          this.loading = false
        }else{
          this.page=this.page+1
          let params={
            cid:4,
            page:this.page
          }
          this.getMypost(params)
          this.loading = false
        }
      }, 500);
    },
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Image.name]:Image,
    [Icon.name]:Icon,
    [ActionSheet.name]:ActionSheet,
    [Divider.name]:Divider,
  }
}
</script>

<style lang="scss">
.mypost{
  .list-box{
    padding: 15px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:100%;
      height:105px;
      border-radius:5px;
      object-fit: cover;
    }
    .listitle{
      font-size: 16px;
      font-weight:bold;
      line-height: 1.8;
      letter-spacing: 1.4px;
    }
    .statenum{
      font-size: 13px;
      color: #605C6B;
      font-weight: bold;
      vertical-align: middle;
    }
    .sourtime{
      font-size:14px;
      color:rgba(154,154,154,1);
    }
    .binpic{
      width:15px;
      height:15px;
      margin-right:8px;
      vertical-align: middle;
    }
    .binbox{
      margin-right:20px;
      .location{
        width:12px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
    }
    .bintright{
      text-align:right;
      .binbox{
        margin-left:20px;
      }
    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .mt-15{
      margin-top: 15px;
    }
    .pic {
      img {
        width: 100%;
        height: 205px;
        object-fit: cover;
        display: block;
        border-radius: 3px;

        &.right {
          height: 100px;
        }
        &.one {
          margin-bottom: 5px;
        }
      }
      .pic-grid{
        width: 33.33%;
        float: left;
        padding: 5px;
        box-sizing:border-box;
        height: 100px;
      }
    }
    .listhand{
      width:45px;
      height:45px;
      border-radius:30px;
    }
    .membername{
      font-size: 15px;
      font-weight: bold;
    }
    .van-tag{
      padding: 2px 10px;
      font-size: 12px;
      margin-right: 5px;
    }
    .quespic{
      width: 22px;
      height: 22px;
    }
    .van-grid-item__content{
      padding: 5px 5px;
    }
  }
  .van-popup{
    .van-action-sheet__cancel::before{
      height: 1px;
    }
    .divider{
      margin: 20px 80px;
    }
  }
  .tag{
    padding: 5px;
    height: 12px;
  }
}
</style>
